(function () {
  if (window.__musklePointsCashRedeemInit) return;
  window.__musklePointsCashRedeemInit = true;

  var DEFAULT_BALANCE_PATH = '/apps/muskle-points/balance';
  var DEFAULT_PREPARE_PATH = '/apps/muskle-points/points-cash/prepare';
  var LABEL_POINTS_ONLY = 'Kopen met punten';
  var LABEL_PARTIAL = 'Gebruik punten + betaal restant';
  var LABEL_CHECKING = 'Punten controleren...';
  var LABEL_PREPARING = 'Voorbereiden...';
  var POINTS_TO_EUR = 0.01;

  function formatEur(amount) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
  }

  function formatPoints(n) {
    return new Intl.NumberFormat('nl-NL').format(n);
  }

  function parseCost(form) {
    var input = form.querySelector('input[name="properties[_muskle_points_cost]"]');
    var n = parseInt(input && input.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  function parseQuantity(form) {
    var input = form.querySelector('input[name="quantity"]');
    var n = parseInt(input && input.value, 10);
    return Number.isFinite(n) && n >= 1 ? n : 1;
  }

  function getRewardLabel(form) {
    var wrap = getWrap(form);
    var card = wrap && wrap.closest('.muskle-points-shop__card');
    if (card) {
      var titleEl = card.querySelector('.muskle-points-shop__card-title, h3, h2');
      if (titleEl && titleEl.textContent) return titleEl.textContent.trim();
    }
    return 'Reward';
  }

  function getWrap(form) {
    return form.closest('.muskle-points-reward-buy-wrap');
  }

  function getMessageEl(form) {
    var wrap = getWrap(form);
    if (!wrap) return null;
    return wrap.querySelector('.muskle-points-reward-message');
  }

  function getPanelEl(form) {
    var wrap = getWrap(form);
    if (!wrap) return null;
    return wrap.querySelector('.muskle-points-partial-cash-panel');
  }

  function showMessage(form, text) {
    var el = getMessageEl(form);
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function resetButton(btn, label) {
    if (!btn) return;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.textContent = label || btn.dataset.musklePointsLabelDefault || LABEL_POINTS_ONLY;
  }

  function setBusy(btn, label) {
    if (!btn) return;
    if (!btn.dataset.musklePointsLabelDefault) {
      btn.dataset.musklePointsLabelDefault = (btn.textContent || '').trim() || LABEL_POINTS_ONLY;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = label;
  }

  function syncSession() {
    if (window.MuskleAccountSession && typeof window.MuskleAccountSession.syncStorefrontSession === 'function') {
      return window.MuskleAccountSession.syncStorefrontSession();
    }
    return Promise.resolve();
  }

  function fetchJson(url, options) {
    return fetch(url, options)
      .then(function (res) {
        return res
          .json()
          .then(function (body) {
            return { ok: res.ok, status: res.status, body: body || {} };
          })
          .catch(function () {
            return { ok: false, status: res.status, body: {} };
          });
      })
      .catch(function () {
        return { ok: false, status: 0, body: {} };
      });
  }

  function computePreview(unitPointsCost, balance, quantity) {
    var qty = quantity >= 1 ? quantity : 1;
    var requiredPoints = unitPointsCost * qty;
    var pointsToUse = Math.min(Math.max(0, balance), requiredPoints);
    var pointsValueEur = Math.round(pointsToUse * POINTS_TO_EUR * 100) / 100;
    var rewardValueEur = Math.round(requiredPoints * POINTS_TO_EUR * 100) / 100;
    var cashRemainingEur = Math.round((rewardValueEur - pointsValueEur) * 100) / 100;
    return {
      quantity: qty,
      reward_value_eur: rewardValueEur,
      required_points: requiredPoints,
      points_to_use: pointsToUse,
      points_value_eur: pointsValueEur,
      cash_remaining_eur: cashRemainingEur,
      balance: balance,
    };
  }

  function formatQuantityLabel(form, preview) {
    var qty = preview && preview.quantity ? preview.quantity : 1;
    if (qty <= 1) return '1';
    return getRewardLabel(form) + ' ×' + qty;
  }

  function updatePanel(form, preview) {
    var panel = getPanelEl(form);
    if (!panel || !preview) return;

    var set = function (sel, text) {
      var el = panel.querySelector(sel);
      if (el) el.textContent = text;
    };

    set('[data-muskle-partial-quantity]', formatQuantityLabel(form, preview));
    set('[data-muskle-partial-value]', formatEur(preview.reward_value_eur));
    set('[data-muskle-partial-required]', formatPoints(preview.required_points) + ' MUSKLE Points');
    set('[data-muskle-partial-balance]', formatPoints(preview.balance) + ' MUSKLE Points');
    set(
      '[data-muskle-partial-used]',
      formatPoints(preview.points_to_use) + ' (' + formatEur(preview.points_value_eur) + ')'
    );
    set('[data-muskle-partial-cash]', formatEur(preview.cash_remaining_eur));
    panel.hidden = false;

    var btn = form.querySelector('.muskle-points-reward-buy-button');
    if (btn) {
      btn.dataset.musklePointsLabelDefault =
        preview.cash_remaining_eur > 0 ? LABEL_PARTIAL : LABEL_POINTS_ONLY;
      if (!btn.disabled) btn.textContent = btn.dataset.musklePointsLabelDefault;
    }
  }

  function ensureHiddenField(form, name, value) {
    var sel = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(sel);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function loadPreview(form) {
    var wrap = getWrap(form);
    if (!wrap || wrap.getAttribute('data-partial-cash') !== 'true') return;

    var balancePath = wrap.getAttribute('data-balance-path') || DEFAULT_BALANCE_PATH;
    var pointsCost = parseCost(form);
    var quantity = parseQuantity(form);
    if (!pointsCost) return;

    syncSession()
      .then(function () {
        return fetchJson(balancePath, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
      })
      .then(function (result) {
        var body = result.body || {};
        if (!result.ok || typeof body.balance !== 'number') {
          var panel = getPanelEl(form);
          if (panel) panel.hidden = true;
          return;
        }
        updatePanel(form, computePreview(pointsCost, body.balance, quantity));
      });
  }

  function refreshPreviewOnQuantityChange(form) {
    var wrap = getWrap(form);
    if (!wrap || wrap.getAttribute('data-partial-cash') !== 'true') return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput || qtyInput.dataset.muskleQtyBound === 'true') return;
    qtyInput.dataset.muskleQtyBound = 'true';
    qtyInput.addEventListener('change', function () {
      loadPreview(form);
    });
    qtyInput.addEventListener('input', function () {
      loadPreview(form);
    });
  }

  function submitCartAdd(form) {
    var formData = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res
        .json()
        .then(function (body) {
          return { ok: res.ok, status: res.status, body: body || {} };
        })
        .catch(function () {
          return { ok: false, status: res.status, body: {} };
        });
    });
  }

  function redirectAfterCartAdd(prepareResult, returnTo) {
    if (prepareResult.discount_code) {
      window.location.href =
        '/discount/' +
        encodeURIComponent(prepareResult.discount_code) +
        '?redirect=' +
        encodeURIComponent(returnTo || '/cart');
      return;
    }
    window.location.href = returnTo || '/cart';
  }

  function callPrepare(wrap, form) {
    var preparePath = wrap.getAttribute('data-prepare-path') || DEFAULT_PREPARE_PATH;
    var productId = wrap.getAttribute('data-reward-product-id') || '';
    var variantId = wrap.getAttribute('data-reward-variant-id') || '';
    var quantity = form ? parseQuantity(form) : 1;
    var payload = { use_max_points: true, quantity: quantity };
    if (productId) payload.reward_product_id = productId;
    if (variantId) payload.reward_variant_id = variantId;

    return fetchJson(preparePath, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  function attachForm(form) {
    if (form.dataset.musklePointsCashBound === 'true') return;
    form.dataset.musklePointsCashBound = 'true';

    var wrap = getWrap(form);
    var partialCash = wrap && wrap.getAttribute('data-partial-cash') === 'true';
    var balancePath = (wrap && wrap.getAttribute('data-balance-path')) || DEFAULT_BALANCE_PATH;

    if (partialCash) {
      loadPreview(form);
      refreshPreviewOnQuantityChange(form);
    }

    form.addEventListener('submit', function (e) {
      if (form.dataset.musklePointsCashAllow === 'true') {
        form.dataset.musklePointsCashAllow = '';
        return;
      }

      e.preventDefault();

      var btn = form.querySelector('.muskle-points-reward-buy-button');
      var pointsCost = parseCost(form);
      var quantity = parseQuantity(form);
      var requiredPoints = pointsCost * quantity;

      if (!pointsCost) {
        showMessage(form, 'We kunnen deze reward nu niet voorbereiden. Probeer opnieuw.');
        resetButton(btn);
        return;
      }

      setBusy(btn, partialCash ? LABEL_PREPARING : LABEL_CHECKING);
      showMessage(form, '');

      syncSession()
        .then(function () {
          if (!partialCash) {
            return fetchJson(balancePath, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            }).then(function (result) {
              var body = result.body || {};
              if (result.status === 401 || body.error === 'login_required') {
                throw { kind: 'login' };
              }
              if (!result.ok || typeof body.balance !== 'number') {
                throw { kind: 'balance_error' };
              }
              if (body.balance < requiredPoints) {
                throw {
                  kind: 'insufficient',
                  balance: body.balance,
                  required: requiredPoints,
                };
              }
              return { legacy: true };
            });
          }
          return callPrepare(wrap, form).then(function (result) {
            var body = result.body || {};
            if (result.status === 401 || body.error === 'login_required') {
              throw { kind: 'login' };
            }
            if (!result.ok || !body.ok) {
              throw { kind: 'prepare_error', body: body };
            }
            return body;
          });
        })
        .then(function (prepareResult) {
          if (prepareResult.legacy) {
            form.dataset.musklePointsCashAllow = 'true';
            form.submit();
            return;
          }

          ensureHiddenField(form, 'properties[_muskle_points_cash_prepare_id]', prepareResult.prepare_id);
          ensureHiddenField(form, 'properties[_muskle_points_used]', String(prepareResult.points_to_use || 0));
          ensureHiddenField(
            form,
            'properties[_muskle_points_cost]',
            String(prepareResult.required_points || pointsCost)
          );

          updatePanel(form, {
            quantity: prepareResult.quantity || quantity,
            reward_value_eur: prepareResult.reward_value_eur,
            required_points: prepareResult.required_points,
            points_to_use: prepareResult.points_to_use,
            points_value_eur: prepareResult.points_value_eur,
            cash_remaining_eur: prepareResult.cash_remaining_eur,
            balance: prepareResult.balance_before,
          });

          var returnTo =
            (form.querySelector('input[name="return_to"]') &&
              form.querySelector('input[name="return_to"]').value) ||
            '/cart';

          return submitCartAdd(form).then(function (cartResult) {
            if (!cartResult.ok) {
              throw { kind: 'cart_error', body: cartResult.body };
            }
            redirectAfterCartAdd(prepareResult, returnTo);
          });
        })
        .catch(function (err) {
          if (err && err.kind === 'login') {
            showMessage(form, 'Log in om MUSKLE Points te gebruiken.');
          } else if (err && err.kind === 'insufficient') {
            showMessage(
              form,
              'Je hebt niet genoeg MUSKLE Points voor deze reward. Je hebt ' +
                err.balance +
                ' punten. Nodig: ' +
                err.required +
                ' punten.'
            );
          } else if (err && err.kind === 'prepare_error') {
            var msg =
              (err.body && err.body.message) ||
              'We kunnen je punten nu niet toepassen. Probeer opnieuw.';
            showMessage(form, msg);
          } else if (err && err.kind === 'cart_error') {
            showMessage(form, 'Toevoegen aan winkelwagen is mislukt. Probeer opnieuw.');
          } else {
            showMessage(form, 'We kunnen je punten nu niet controleren. Probeer opnieuw.');
          }
          var preview = computePreview(pointsCost, 0, quantity);
          var label = partialCash && preview.cash_remaining_eur > 0 ? LABEL_PARTIAL : LABEL_POINTS_ONLY;
          resetButton(btn, label);
        });
    });
  }

  function init() {
    document.querySelectorAll('form.muskle-points-reward-form').forEach(attachForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
